export const killPreloader = () => {
  const el = document.getElementById('preloader');
  if (el) {
    el.style.opacity = '0';
    el.style.transition = 'opacity .2s ease';
    setTimeout(() => el.remove(), 220);
  }
};
